import {
	Component,
	Input,
	ViewChild,
	ChangeDetectionStrategy,
	Output,
	EventEmitter,
} from "@angular/core"
import { COMMON_IMPORTS } from "../../common-imports"
import { PolicyFormVersion } from "@app/definitions/types"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { BtnExtComponent } from "@app/utils/utils.component"
import { WysiwygComponent } from "@app/utils/wysiwyg/wysiwyg.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { Modalable } from "@app/Modalable"
import { Fields } from "./fields/fields.component"

@Component({
	selector: "version",
	imports: [
		COMMON_IMPORTS,
		GenInputComponent,
		WysiwygComponent,
		Fields,
		LangValPipe,
		BtnExtComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./version.component.html",
})
export class Version extends Modalable {
	@Input() actObject: PolicyFormVersion
	@Input() disabled: boolean
	@ViewChild("firstField") firstField: GenInputComponent
	@Output() onSaveNew = new EventEmitter()

	isSaving: boolean = false
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		main_text: { not_empty: true },
	}
	async ngOnInit() {
		this.firstField?.focus()
	}
	validateAndSave(fieldName: string) {
		if (!this.actObject?.id) {
			return this.validateEntireForm()
		}
		this.validateEntireForm()
		this.saveField(fieldName)
	}
	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.actObject,
			this.errors,
			this.validationFields
		)
	}
	async saveField(fieldName: string) {
		if (!this.isFormSubmittable) {
			return
		}

		const res: any = await this.apiService.save_gen_field(
			"policy_form_versions",
			this.actObject?.id,
			fieldName,
			this.actObject?.[fieldName]
		)
		if (res?.success) {
			this.store.updGenItemRowField(
				"policy_form_versions",
				this.actObject?.id,
				fieldName,
				this.actObject?.[fieldName]
			)
			this.modalService.openToast("update_successfuly")
		} else {
			this.modalService.openToast("save_failed")
		}
	}
	async save() {
		//save the contact
		if (!this.isFormSubmittable) {
			return
		}
		await this.apiService.sendApiGetPerms()
		if (
			!this.apiService.apiCallPerms ||
			!this.apiService.apiCallPerms.policy_form_versions?.saveNewRow
		) {
			return
		}
		this.isSaving = true
		const res: any = await this.apiService.save_gen_item(
			"policy_form_versions",
			{
				...this.actObject,
			}
		)
		this.isSaving = false
		if (res.id) {
			this.actObject = res
			this.store.addGenItemRow("policy_form_versions", res)
			this.onSaveNew.emit(this.actObject)
		}
		this.modalService.openToast(
			res?.id ? "saved_successfully" : res?.mes || "save_failed"
		)
	}
}
